import { render, staticRenderFns } from "./TrucksTable.vue?vue&type=template&id=4b24cc6b&scoped=true"
import script from "./TrucksTable.vue?vue&type=script&lang=js"
export * from "./TrucksTable.vue?vue&type=script&lang=js"
import style0 from "./TrucksTable.vue?vue&type=style&index=0&id=4b24cc6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b24cc6b",
  null
  
)

export default component.exports